import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { getUser } from '../lib/db/users';
import { trackEvent, EVENTS } from '../lib/analytics';

export const useUserProfile = () => {
  const { currentUser } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserProfile = async () => {
    if (!currentUser) {
      setUserProfile(null);
      setLoading(false);
      setError(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const profile = await getUser(currentUser.uid);
      setUserProfile(profile);
    } catch (err) {
      console.error('Error fetching user profile:', err);
      setError(err);
      trackEvent(EVENTS.ERROR_OCCURRED, {
        errorType: 'fetch_user_profile',
        errorMessage: err.message
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, [currentUser]);

  return {
    userProfile,
    loading,
    error,
    refetch: fetchUserProfile,
    clearError: () => setError(null)
  };
};
